import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import AdminNavbarItem from '../../src/admin/layout/components/AdminNavbarItem';
import useFlipper from '../../modules/react/hooks/useFlipper';
import { FLIPPER_RENTAL_CENTER_OPTIONS } from '../../constants/flippers';

const { RENTAL_CENTAUR_HOST, RENTAL_CENTAUR_LOGIN_PATH } = process.env;

const GET_COMPANY_ID = gql`
  query GetAdminRentalCenterNavbarItemData {
    currentSite {
      id
      companyId
    }
  }
`;

const propTypes = {};
const defaultProps = {};

const AdminRentalCenterNavbarItem = () => {
  const { data, loading } = useQuery(GET_COMPANY_ID);
  const enabled = useFlipper(FLIPPER_RENTAL_CENTER_OPTIONS);

  if (!enabled) {
    return null;
  }

  let href;

  if (data) {
    const { currentSite: { companyId } } = data;

    href = `${RENTAL_CENTAUR_HOST}${RENTAL_CENTAUR_LOGIN_PATH}?se_company_id=${companyId}`;
  }

  return (
    <AdminNavbarItem
      icon="move-in"
      text="Rental Center 2.0"
      componentClass="a"
      href={href}
      target="_blank"
      disabled={loading}
    />
  );
};

AdminRentalCenterNavbarItem.propTypes = propTypes;
AdminRentalCenterNavbarItem.defaultProps = defaultProps;

export default AdminRentalCenterNavbarItem;
